/** Tiny connection status dot — colored circle. */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";

export function ConnectionDot(): ReactElement {
  const { state } = useStore();
  const c = state.connection.kind;
  const color =
    c === "welcomed"
      ? "#3aa675"
      : c === "connecting" || c === "idle"
        ? "#c8a13a"
        : "#e04040";
  const label =
    c === "welcomed"
      ? "connected"
      : c === "connecting"
        ? "connecting"
        : c === "idle"
          ? "idle"
          : c === "protocolMismatch"
            ? "mismatch"
            : "disconnected";
  return (
    <div
      data-testid="connection-dot"
      data-state={c}
      title={label}
      style={{
        width: 12,
        height: 12,
        borderRadius: "50%",
        background: color,
        boxShadow: "0 0 4px rgba(0,0,0,0.3)",
      }}
    />
  );
}
